import { useState } from 'react';

interface Props {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  submit?: boolean;
}

export const NavButtons = ({ onBack, onNext, nextLabel = 'Continue', nextDisabled, submit }: Props) => {
  const [showSaved, setShowSaved] = useState(false);

  return (
    <>
      <div className="mt-6 flex items-center justify-between gap-3 border-t border-ink-50 pt-5">
        {onBack ? (
          <button type="button" onClick={onBack} className="btn-dark">
            ‹ Back
          </button>
        ) : (
          <span />
        )}
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => setShowSaved(true)}
            className="text-[11px] font-semibold uppercase tracking-wide text-ink-500 underline hover:text-ink-900"
          >
            Save &amp; return later
          </button>
          <button
            type={submit ? 'submit' : 'button'}
            onClick={submit ? undefined : onNext}
            disabled={nextDisabled}
            className="btn-teal"
          >
            {nextLabel}
          </button>
        </div>
      </div>
      {showSaved && <SavedModal onClose={() => setShowSaved(false)} />}
    </>
  );
};

const SavedModal = ({ onClose }: { onClose: () => void }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
    onClick={onClose}
  >
    <div
      className="max-w-md rounded-md bg-white p-6 shadow-xl"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="mb-3 text-lg font-bold text-ink-900">Your progress is saved</h3>
      <p className="mb-2 text-sm text-ink-700">
        You can close this tab at any time. When you come back to this page in the same
        browser, your form will pick up where you left off.
      </p>
      <p className="mb-4 text-[12px] italic text-ink-500">
        Tip: to save what you have just typed on this page, click <strong>Continue</strong> first
        — otherwise only the previous steps are saved.
      </p>
      <div className="flex justify-end">
        <button type="button" onClick={onClose} className="btn-teal">
          Got it
        </button>
      </div>
    </div>
  </div>
);
